import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-table-action-buttons',
    templateUrl: './table-action-buttons.component.html',
    standalone: false
})
export class TableActionButtonsComponent {
  @Input() isLoading!: boolean;

  @Output() fetchTableData = new EventEmitter<void>();
  @Output() clearFilters = new EventEmitter<void>();
}
